// In-app confirmation dialogs, replacing window.confirm() / window.prompt().
//
// The native dialogs block the whole page, can't be styled, can't say *what*
// is about to be deleted in a readable way, and put the focus on "OK", so a
// stray Enter confirmed an irreversible delete. This one is rendered once by
// ConfirmDialog.vue (mounted in App.vue): the safe choice has the focus, and
// irreversible actions can ask the user to type a word first.

import { ref } from "vue"

/** The dialog being shown, or null. Read by ConfirmDialog.vue. */
export const confirmState = ref(null)

/**
 * Ask the user to confirm; resolves true (confirmed) or false (cancelled).
 *
 *   if (!(await ask({ title: "Удалить клиента?", message: "…", confirmLabel: "Удалить", danger: true }))) return
 *
 * Options: title, message, confirmLabel ("Подтвердить"), cancelLabel ("Отмена"),
 * danger (red confirm button), requireText (the user must type this to enable
 * confirm, for irreversible actions). A plain string is taken as the title.
 */
export function ask(options) {
  const opts = typeof options === "string" ? { title: options } : options
  // A second ask while one is open cancels the first rather than stacking.
  confirmState.value?.resolve(false)
  return new Promise((resolve) => {
    confirmState.value = {
      confirmLabel: "Подтвердить", cancelLabel: "Отмена", danger: false, requireText: "", message: "",
      ...opts,
      kind: "confirm",
      resolve: (v) => { confirmState.value = null; resolve(v) },
    }
  })
}

/** Show `text` selected in a dialog, for copying by hand when the clipboard is refused. */
export function showForCopy(text, title = "Скопируйте ссылку") {
  confirmState.value?.resolve(false)
  return new Promise((resolve) => {
    confirmState.value = { kind: "copy", title, text, resolve: () => { confirmState.value = null; resolve() } }
  })
}
